import { Link } from 'react-router-dom';
import { useInfrastructureHeroContent } from '../../../../hooks/useInfrastructureHeroContent';
import heroImage from '../../../../assets/images/infrastructure/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useInfrastructureHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, cta, image } = content;

  return (
    <section className="infrastructure-hero">
      <div className="infrastructure-hero__inner">
        <div className="infrastructure-hero__copy">
          {eyebrow ? <p className="infrastructure-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="infrastructure-hero__title">{title}</h1>
          {text ? <p className="infrastructure-hero__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="infrastructure-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="infrastructure-hero__media">
        <img
          className="infrastructure-hero__image"
          src={image || heroImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default Hero;
